import React, { FC, useEffect, useState } from 'react';
import { useLocation, useMatch } from 'react-router-dom';
import { API } from 'shared/api/loan';
import { useGeneralInfoContext } from 'shared/context/WithGeneralInfo/GeneralInfoContext';
import { IProductData } from 'shared/model';
import { isQrRedirectionRoute } from 'shared/utils/qrRedirectionRoute';

import { MAIN_PATH } from 'routes/consts';

import InfoTabs from 'components/InfoTabs';
import ProductInfo from 'components/ProductInfo';

import Container from '../Container';

import './index.scss';

const OrderStepWrapper: FC = ({ children }) => {
  const { rest, productCode } = useGeneralInfoContext();
  const [productData, setProductData] = useState<IProductData>({});
  const { pathname } = useLocation();
  const isFirstPage = !!useMatch(MAIN_PATH);
  const showQrRedirectionFirst = isQrRedirectionRoute(pathname);

  useEffect(() => {
    rest.get<Array<IProductData>>(API.loan.getProductInfo(productCode)).then(response => {
      setProductData(response?.data[0]);
    });
  }, []);

  return (
    <Container>
      {showQrRedirectionFirst ? (
        <div className="order-step-layout order-step-layout--qr-first-mobile">
          <div className="order-step-wrapper">{children}</div>
          <div className="order-step-layout__product">
            <ProductInfo productData={productData} />
          </div>
        </div>
      ) : (
        <>
          <ProductInfo productData={productData} />
          <div className="order-step-wrapper">{children}</div>
        </>
      )}
      {isFirstPage && <InfoTabs productData={productData} />}
    </Container>
  );
};

export default OrderStepWrapper;
